<div [@routeAnimations]="getRouteAnimationData()">
    <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
</div>
